const testDetailsMap = {
	categories: {
		icon: 'people',
		title: 'Test category:',
	},
	method: {
		icon: 'info',
		title: 'Test type:',
	},
	cost: {
		icon: 'monetization_on',
		title: 'Cost:',
	},
	processingTime: {
		icon: 'watch_later',
		title: 'Processing time:',
	},
};

export { testDetailsMap };
